import type { ReferenceSlokaItem } from '@/ayurveda/types/ayurveda';

interface ReferenceSlokaCardProps {
  sloka: ReferenceSlokaItem;
  index: number;
}

export function ReferenceSlokaCard({ sloka, index }: ReferenceSlokaCardProps) {
  return (
    <div className="min-w-0 space-y-3 rounded-lg border border-border/50 bg-background/50 p-4">
      <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <h4 className="min-w-0 break-words font-hanken text-[16px] font-semibold text-[#42434B]">
          {index + 1}. {sloka.title}
        </h4>
        <span className="max-w-full break-words rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800 sm:max-w-[45%]">
          {sloka.source}
        </span>
      </div>

      <div className="rounded-md border border-amber-200/40 bg-amber-50/60 p-3">
        <p className="break-words font-serif text-[15px] italic leading-relaxed text-amber-900">
          {sloka.sanskrit}
        </p>
      </div>

      <div className="space-y-1.5">
        <p className="text-sm font-medium text-muted-foreground">Meaning</p>
        <p className="break-words font-hanken text-[14px] leading-6 text-[#585859]">
          {sloka.meaning}
        </p>
      </div>

      {sloka.clinical_interpretation && (
        <div className="space-y-1.5">
          <p className="text-sm font-medium text-muted-foreground">Clinical Interpretation</p>
          <p className="break-words font-hanken text-[14px] leading-6 text-[#585859]">
            {sloka.clinical_interpretation}
          </p>
        </div>
      )}
    </div>
  );
}
